import React, { useState, useEffect } from "react";
import CustomModal from "../../../components/common/general/CustomModal/CustomModal";
import EditAssignment from "../EditAssignment/EditAssignment";

const EditAddAssignmentModalContainer = ({
  visible,
  onClose,
  initialContent,
  currentName = "",
  onSaveItem,
  moduleName,
  activelyEditingState,
}) => {
  const [name, setName] = useState("");

  useEffect(() => {
    if (currentName !== "") {
      setName(currentName);
    }

    return () => {
      setName("");
    };
  }, [visible]);

  const isNewItem = currentName === "";

  const onChangeName = (text) => {
    setName(text);
  };

  return (
    <CustomModal
      visible={visible}
      onRequestClose={onClose}
      showCloseButton={true}
      title={isNewItem ? `Add Assignment` : `Edit Assignment`}>
      <EditAssignment
        onClose={onClose}
        onSave={(htmlContent) => onSaveItem(type, htmlContent, name, moduleName)}
        initialContent={initialContent}
        newName={name}
        onChangeName={onChangeName}
        buttonText={isNewItem ? "Add" : "Save"}
        type={type}
        activelyEditingState={activelyEditingState}
      />
    </CustomModal>
  );
};

export default EditAddAssignmentModalContainer;
